import useMeetClassificationMultiSelect from './UseMeetClassificationMultiSelect';
import MultiSelect from '../MultiSelect';

const MeetClassificationMultiSelect = ({ label, name, value, error, message, onChange }) => {
  const { options } = useMeetClassificationMultiSelect();
  return (
    <MultiSelect
      label={label}
      name={name}
      value={value}
      options={options}
      error={error}
      message={message}
      isLoading={false}
      onChange={onChange}
    />
  );
}

export default MeetClassificationMultiSelect;